var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class:
                _vm.method === "view" || _vm.method === "read"
                  ? "readonly"
                  : "",
              attrs: {
                size: "small",
                model: _vm.inputForm,
                disabled: _vm.method === "view" || _vm.method === "read",
                "label-width": "120px",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.doSubmit()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "类型",
                            prop: "type",
                            rules: [
                              {
                                required: true,
                                message: "类型不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.inputForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm, "type", $$v)
                                },
                                expression: "inputForm.type",
                              },
                            },
                            _vm._l(
                              _vm.$dictUtils.getDictList("oa_notify_type"),
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "标题",
                            prop: "title",
                            rules: [
                              {
                                required: true,
                                message: "标题不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写标题" },
                            model: {
                              value: _vm.inputForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "title", $$v)
                              },
                              expression: "inputForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "内容",
                            prop: "content",
                            rules: [
                              {
                                required: true,
                                message: "内容不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 8,
                              placeholder: "请填写内容",
                            },
                            model: {
                              value: _vm.inputForm.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "content", $$v)
                              },
                              expression: "inputForm.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "附件", prop: "files" } },
                        [
                          _c(
                            "file-upload",
                            {
                              attrs: {
                                limit: 3,
                                tip: "最多上传3个文件,单个文件不要超过10M,请上传xlsx/docx格式文件",
                              },
                              model: {
                                value: _vm.inputForm.files,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm, "files", $$v)
                                },
                                expression: "inputForm.files",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-upload",
                                  },
                                },
                                [_vm._v("上传附件")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.method !== "read"
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "状态",
                                prop: "status",
                                rules: [
                                  {
                                    required: true,
                                    message: "状态不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.inputForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.inputForm, "status", $$v)
                                    },
                                    expression: "inputForm.status",
                                  },
                                },
                                _vm._l(
                                  _vm.$dictUtils.getDictList(
                                    "oa_notify_status"
                                  ),
                                  function (item) {
                                    return _c(
                                      "el-radio",
                                      {
                                        key: item.id,
                                        attrs: { label: item.value },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "接收人",
                            prop: "notifyRecordIds",
                            rules: [
                              {
                                required: true,
                                message: "接收人不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("user-select", {
                            attrs: { value: _vm.inputForm.notifyRecordIds },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.notifyRecordIds = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.method === "view" && _vm.inputForm.status === "1"
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "接收人" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    size: "small",
                                    data: _vm.notifyRecordDTOList,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "userDTO.name",
                                      label: "接收人",
                                      width: "180",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "userDTO.officeDTO.name",
                                      label: "接收部门",
                                      width: "180",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "readFlag",
                                      label: "阅读状态",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.readFlag === "1"
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$dictUtils.getDictLabel(
                                                              "oa_notify_read",
                                                              scope.row
                                                                .readFlag,
                                                              "-"
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              scope.row.readFlag === "0"
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: { type: "danger" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$dictUtils.getDictLabel(
                                                              "oa_notify_read",
                                                              scope.row
                                                                .readFlag,
                                                              "-"
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      203415661
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "readDate",
                                      label: "阅读时间",
                                      width: "180",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view" && _vm.method != "read"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }